var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 677.9 674.8",
    style: {
      enableBackground: "new 0 0 677.9 674.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFC10D;}\r\n\t.st1{fill:#194F82;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M339,367.4c-66.7,0-199,36.3-200,102.7c43,64.7,116.7,107.3,200,107.3s157-42.7,200-107.3 C538,403.7,405.3,367.4,339,367.4z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -45.0127 299.4456)",
    className: "st0",
    cx: 339,
    cy: 204.1,
    rx: 100,
    ry: 100
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M339,4.1C155,4.1,5.6,153.4,5.6,337.4S155,670.7,339,670.7s333.3-149.3,333.3-333.3S523,4.1,339,4.1z  M339,577.4c-83.3,0-157-42.7-200-107.3c1-66.3,133.3-102.7,200-102.7c66.3,0,199,36.3,200,102.7C496,534.7,422.3,577.4,339,577.4z  M239,204.1c0-55.3,44.7-100,100-100s100,44.7,100,100s-44.7,100-100,100S239,259.4,239,204.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.94364b30f0ea890aa878280e25c9fb63.svg";
export { ForwardRef as ReactComponent };